import clsx from 'clsx'

import { Badge } from '@wartek-id/badge'

import { getApprovalStateProps } from 'app/KinerjaTimPenilaiPSPage/utils/status'

import type { StatusPerencanaan } from 'types/kinerja-ps-pegawai'

export default function PlanningApprovalBadge({
  state,
}: {
  state: StatusPerencanaan
}) {
  const { color, badgeClassName, text } = getApprovalStateProps(state)

  return (
    <Badge variant={color} className={clsx('w-fit', badgeClassName)}>
      {text}
    </Badge>
  )
}
